import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';

import * as c from './../../../libs/constants';

import { Head } from '../../ui/head';

const HeaderView = ({ activeAuthTab, changeAuthTab, closeDialog }) => {
    let tabName;
    let startPage;

    switch (activeAuthTab) {
        case c.CHAT_AUTH_REGISTER:
            tabName = t`Регистрация`;
            break;
        case c.CHAT_AUTH_LOGIN:
            tabName = t`Войти`;
            break;
        default:
            tabName = t`Войти в кабинет`;
            startPage = true;
    }

    return (
        <Head
            dataQa='chat_header'
            onBack={startPage
                ? closeDialog
                : changeAuthTab(c.CHAT_AUTH_SOCIAL, c.ANALCS_ACTION_REGISTER_BACK)
            }
        >
            {tabName}
        </Head>
    );
};

HeaderView.propTypes = {
    activeAuthTab: PropTypes.string,
    changeAuthTab: PropTypes.func,
    closeDialog: PropTypes.func,
};


const mapStateToProps = (state) => ({
    activeAuthTab: state.get('activeAuthTab'),
    locale: state.get('locale')
});

export const Header = connect(mapStateToProps)(HeaderView);
